import FormTypes from 'forms-utils-lib/constants/formDefinition/FormTypes';
import { useFetchFlows } from 'asset-actions-lib-forms/delete/hooks/useFetchFlows';
import { getSourceAppNameFromFormType } from 'asset-actions-lib-forms/utils/appSource';
const useHasWorkflows = args => {
  const {
    formType = FormTypes.HUBSPOT,
    guid = ''
  } = args;
  const {
    data,
    loading
  } = useFetchFlows({
    sourceApp: getSourceAppNameFromFormType(formType),
    guid
  });
  const hasWorkflows = data ? data.length > 0 : false;
  return {
    hasWorkflows,
    loading
  };
};
export default useHasWorkflows;